import React from 'react';
import { useI18n } from '../i18n/I18nProvider.jsx';
import LanguageSwitcher from '../components/LanguageSwitcher';

export default function Header() {
  const { t } = useI18n();
  return (
    <header className="header">
      <a href="/" className="header__logo">
        <svg viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18.75 2.1C15.18 2.1 12.28 5 12.28 8.56s2.9 6.45 6.47 6.45 6.47-2.89 6.47-6.45S22.32 2.1 18.75 2.1Z" fill="url(#hg1)"/>
          <path d="M7.65 15.64c-2.2 0-4 1.79-4 3.99s1.79 3.99 4 3.99 4-1.79 4-3.99-1.8-3.99-4-3.99Z" fill="url(#hg2)"/>
          <path d="M19.99 19.94c-1.86 0-3.38 1.51-3.38 3.37s1.52 3.37 3.38 3.37 3.38-1.51 3.38-3.37-1.52-3.37-3.38-3.37Z" fill="url(#hg3)"/>
          <defs>
            <linearGradient id="hg1" x1="12.28" y1="8.56" x2="25.22" y2="8.56" gradientUnits="userSpaceOnUse"><stop stopColor="#3B71FE"/><stop offset="1" stopColor="#01D0FD"/></linearGradient>
            <linearGradient id="hg2" x1="3.64" y1="19.63" x2="11.66" y2="19.63" gradientUnits="userSpaceOnUse"><stop stopColor="#3B71FE"/><stop offset="1" stopColor="#01D0FD"/></linearGradient>
            <linearGradient id="hg3" x1="16.61" y1="23.32" x2="23.37" y2="23.32" gradientUnits="userSpaceOnUse"><stop stopColor="#3B71FE"/><stop offset="1" stopColor="#01D0FD"/></linearGradient>
          </defs>
        </svg>
        <h1>Flautreach</h1>
      </a>
      <div className="btn-group">
        <LanguageSwitcher />
        <a href="https://flautreach.com/auth"><button className="btn-reg">{t('header.signup')}</button></a>
        <a href="https://flautreach.com/auth"><button className="btn-login">{t('header.login')}</button></a>
      </div>
    </header>
  );
}